module.exports = __webpack_public_path__ + "img/gaku_text_07.8a290ec3.png";